import { ajax } from 'rxjs/ajax'
import uuid from 'uuidv4'
import { getPublicServerUrl } from './constants'

import * as RasaCookies from 'generic/cookies'
import * as AuthConstants from 'auth/constants'

export const isLocal = (): boolean => {
  return window.location.href.startsWith('http://localhost:')
}

export const redirectTo = (host: string, queryParams: string[]) => {
  const cookie: RasaCookies.RasaCookie = {
    maxAge: 30,
    name: `t${Date.now()}`,
    value: window.localStorage.getItem(AuthConstants.RASA_AUTH_TOKEN),
  }
  RasaCookies.setCookie(cookie)

  let url: URL;
  try {
    url = new URL(host);
  } catch (error) {
    url = new URL(window.location.origin);
  }

  queryParams.push(`${RasaCookies.REDIRECT_COOKIE_PARAM}=${cookie.name}`);

  url.search = queryParams.join('&');
  window.location.href = url.toString();
}

export const generateGuid = () => uuid()

export const writeLog = (payload) => {
  if ( process.env.SKIP_LOG ) {
    return
  } else {
    try {
      const url: string = getPublicServerUrl() + '/monitoring/dashboard/log'
      const headers = {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'rxjs-custom-header': 'Rxjs',
      }
      return ajax({
        body: payload,
        headers,
        method: 'POST',
        url,
      }).toPromise()
    } catch (error) {
      // do nothing. No need to print. Error would in the network
    }
  }
}
